<template>
    <div>
        <div class="el-form-item__error el-form-item__error--inline" v-if="errors.findIndex( x => x.key == prop) > -1" style="margin-left: 0">
            {{ errors.find( x => x.key == prop).message }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'UploadError',
    componentName: 'UploadError',
    props: {
        prop: String,
        errors: {
            type: Array,
            default: () => []
        },
        validateMessage: {
            type: String,
            default: 'Upload obrigatório'
        }
    }
}
</script>
